import { useAuthStore } from '@/stores/auth'
import { useFamilyBookStore } from '@/stores/family_book'
import { useFormStore } from '@/stores/form'
import { useLookupsStore } from '@/stores/lookups'
import { defineStore } from 'pinia'
import { useRoute } from 'vue-router'
import client_lookups from '@/assets/json/clientLookups.json'

export const usePreloadStore = defineStore('preloadStore', () => {
  const authStore = useAuthStore()
  const familyBookStore = useFamilyBookStore()
  const lookupsStore = useLookupsStore()
  const route = useRoute()

  const prepareForm = async () => {
    const departments = await lookupsStore.fetchLookup('/api/lookup/departments')
    const formStore = useFormStore()

    const {
      adminRegions: { ain, dhafra, abuDhabi, dubai },
      dubaiEmirateId,
      relationships: { parent, samePerson }
    } = client_lookups

    const { personUN, familyRelationship, wifeCityCode, wifeFamilySequency } = route.query

    const {
      identityNumber,
      arabicFullName,
      englishFullName,
      passportNumber,
      familyBookCityCode,
      familySequence,
      unifiedNumber,
      arabicFatherName,
      arabicFirstName1,
      arabicFourthName,
      arabicGrandName,
      englishFatherName,
      englishFirstName,
      englishFourthName,
      englishGrandName,
      faithId,
      professionId,
      religionId
    } = authStore.individualInfo

    Object.assign(formStore.draft.request, {
      personUnifiedNumber: unifiedNumber,
      applicantIdentityNumber: identityNumber,
      applicantArbFullName: arabicFullName,
      applicantEngFullName: englishFullName,
      identityNumber,
      localPassportNumber: passportNumber,
      familyBookCityCode: familyBookCityCode,
      familyBooKFamilySequence: familySequence,
      applicantArbFatherName: arabicFatherName,
      applicantArbFirstName: arabicFirstName1,
      applicantArbFourthName: arabicFourthName,
      applicantArbThirdName: arabicGrandName,
      applicantEngFatherName: englishFatherName,
      applicantEngFirstName: englishFirstName,
      applicantEngFourthName: englishFourthName,
      applicantEngThirdName: englishGrandName,
      applicantFaithId: faithId,
      applicantProfessionId: professionId,
      applicantReligionId: religionId,
      arabicName: arabicFullName,
      englishName: englishFullName,
      sponsorNumber: unifiedNumber
    })

    await familyBookStore.getFamilyBookMembers({
      UnifiedNumber: personUN,
      FamilyRelationId: parent,
      pageSize: 100,
      currentPage: 1
    })

    if (familyBookStore.members?.collection?.length <= 0) return

    const [
      {
        familyRecImmigDepartmentId,
        cityCode,
        familySequence: familyMemberFamilySequence,
        identityNumber: familyMemberIdentityNumber,
        unifiedNumber: familyMemberUnifiedNumber,
        arabicName,
        englishName,
        arabicMotherName,
        englishMotherName,
        arbFatherMotherName,
        dateOfBirth,
        arabicFirstName
      }
    ] = familyBookStore.members.collection

    // also handled in setRelationship useDropdownAction
    if (+familyRelationship === +parent) {
      formStore.draft.request.lookupLocalRelationId = samePerson
    } else {
      formStore.draft.request.lookupLocalRelationId = +familyRelationship
    }

    Object.assign(formStore.draft.request, {
      familyBookCityCode: cityCode,
      familyBooKFamilySequence: familyMemberFamilySequence,
      familyMemIdnNumber: familyMemberIdentityNumber,
      familyMemUnNumber: familyMemberUnifiedNumber,
      familyMemArbFullName: arabicName,
      familyMemEngFullName: englishName,
      currentArbMotherName: arabicMotherName,
      currentEngMotherName: englishMotherName,
      currentArbFatherMotherName: arbFatherMotherName,
      currentDateOfBirth: dateOfBirth,
      currentFirstName: arabicFirstName
    })

    const mainDepartmentId = departments.find(
      (d) => d.id == familyRecImmigDepartmentId
    )?.administrativeRegionId

    Object.assign(formStore.draft.request, {
      mainDepartmentId
    })

    if (mainDepartmentId) {
      if ([ain, dhafra, abuDhabi].includes(mainDepartmentId)) {
        formStore.draft.request.localEmirateId = abuDhabi
      } else if (mainDepartmentId === dubai) {
        formStore.draft.request.localEmirateId = dubaiEmirateId
      } else {
        formStore.draft.request.localEmirateId = mainDepartmentId
      }
    }
  }

  const actions = { prepareForm }

  return { ...actions }
})

export default async function () {
  await usePreloadStore().prepareForm()
}
